import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GetCountriesService } from './get-countries/get-countries.service';

@NgModule({
  imports: [CommonModule],
  providers: [GetCountriesService],
})
export class CountriesModule {}